<template>
  <div>
    <Page :title="pageTitle" :isFullWidth="true">
      <template v-slot:action>
        <div class="Polaris-Page-Header__PrimaryActionWrapper">
          <div class="Polaris-Box Polaris-Box--printHidden">
            <button
              class="Polaris-Button Polaris-Button--pressable Polaris-Button--variantSecondary Polaris-Button--sizeMedium Polaris-Button--textAlignCenter mr-2"
              type="button"
              @click="openTemplates"
            >
              <span
                class="Polaris-Text--root Polaris-Text--bodySm Polaris-Text--medium"
                >Templates</span
              >
            </button>
            <button
              class="Polaris-Button Polaris-Button--pressable Polaris-Button--variantPrimary Polaris-Button--sizeMedium Polaris-Button--textAlignCenter"
              type="button"
              @click="refreshCurrentPage"
              :disabled="isLoading"
            >
              <span
                class="Polaris-Text--root Polaris-Text--bodySm Polaris-Text--medium"
                >Refresh</span
              >
            </button>
          </div>
        </div>
      </template>
      <template v-slot:default>
        <div class="flex flex-col max-w-7xl mx-auto my-10">
          <div
            class="-my-2 py-2 overflow-x-auto sm:-mx-6 sm:px-6 lg:-mx-8 lg:px-8"
          >
            <div v-if="isLoading">
              <Spinner />
            </div>

            <div class="flex flex-col">
              <div
                class="-my-2 py-2 overflow-x-auto sm:-mx-6 sm:px-6 lg:-mx-8 lg:px-8 "
              >
                <!-- <ManualMessageAlert /> -->

                <div class="Polaris-LegacyCard">
                  <div
                    class="Polaris-IndexFilters__IndexFiltersWrapper"
                    style="height: 82px;"
                  >
                    <div></div>
                    <div class="Polaris-IndexFilters">
                      <div></div>
                      <div>
                        <div class="">
                          <div class="Polaris-Filters__Container">
                            <div
                              class="Polaris-Box"
                              style="--pc-box-padding-block-start-xs:var(--p-space-200);--pc-box-padding-block-end-xs:var(--p-space-200);--pc-box-padding-inline-start-xs:var(--p-space-200);--pc-box-padding-inline-end-xs:var(--p-space-200)"
                            >
                              <div
                                class="Polaris-InlineStack"
                                style="--pc-inline-stack-align:start;--pc-inline-stack-block-align:center;--pc-inline-stack-wrap:wrap;--pc-inline-stack-gap-xs:var(--p-space-400);--pc-inline-stack-gap-md:var(--p-space-300);--pc-inline-stack-flex-direction-xs:row"
                              >
                                <div
                                  class="Polaris-Filters__SearchField"
                                  style="transition:opacity var(--p-motion-duration-150) var(--p-motion-ease);opacity:1"
                                >
                                  <div class="Polaris-Labelled--hidden">
                                    <div class="Polaris-Labelled__LabelWrapper">
                                      <div class="Polaris-Label">
                                        <label
                                          id=":R2qcq6:Label"
                                          for=":R2qcq6:"
                                          class="Polaris-Label__Text"
                                        >
                                          <span
                                            class="Polaris-Text--root Polaris-Text--bodyMd"
                                            >Search By Order Id</span
                                          >
                                        </label>
                                      </div>
                                    </div>
                                    <div class="Polaris-Connected">
                                      <div
                                        class="Polaris-Connected__Item Polaris-Connected__Item--focused Polaris-Connected__Item--primary"
                                      >
                                        <div
                                          class="Polaris-TextField Polaris-TextField--focus Polaris-TextField--borderless Polaris-TextField--slim"
                                        >
                                          <div
                                            class="Polaris-TextField__Prefix Polaris-TextField__PrefixIcon"
                                            id=":R2qcq6:-Prefix"
                                          >
                                            <span
                                              class="Polaris-Text--root Polaris-Text--bodyMd"
                                            >
                                              <span class="Polaris-Icon">
                                                <svg
                                                  viewBox="0 0 20 20"
                                                  class="Polaris-Icon__Svg"
                                                  focusable="false"
                                                  aria-hidden="true"
                                                >
                                                  <path
                                                    fill-rule="evenodd"
                                                    d="M12.323 13.383a5.5 5.5 0 1 1 1.06-1.06l2.897 2.897a.75.75 0 1 1-1.06 1.06l-2.897-2.897Zm.677-4.383a4 4 0 1 1-8 0 4 4 0 0 1 8 0Z"
                                                  ></path>
                                                </svg>
                                              </span>
                                            </span>
                                          </div>
                                          <input
                                            id=":R2qcq6:"
                                            placeholder="Search By order Id"
                                            autocomplete="off"
                                            v-model="searchText"
                                            class="Polaris-TextField__Input Polaris-TextField__Input--hasClearButton"
                                            type="text"
                                            aria-labelledby=":R2qcq6:Label :R2qcq6:-Prefix"
                                            aria-invalid="false"
                                            data-1p-ignore="true"
                                            data-lpignore="true"
                                            data-form-type="other"
                                            @keydown.enter="loadPage(1)"
                                          />
                                          <div
                                            class="Polaris-TextField__Backdrop"
                                          ></div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                <div class="Polaris-IndexFilters__ButtonWrap">
                                  <div
                                    class="Polaris-InlineStack"
                                    style="--pc-inline-stack-align:start;--pc-inline-stack-block-align:center;--pc-inline-stack-wrap:wrap;--pc-inline-stack-gap-xs:var(--p-space-200);--pc-inline-stack-flex-direction-xs:row"
                                  >
                                    <div
                                      style="transition:opacity 150ms var(--p-motion-ease);opacity:1"
                                    >
                                      <div
                                        class="Polaris-InlineStack"
                                        style="--pc-inline-stack-align:start;--pc-inline-stack-block-align:center;--pc-inline-stack-wrap:wrap;--pc-inline-stack-gap-xs:var(--p-space-100);--pc-inline-stack-flex-direction-xs:row"
                                      >
                                        <button
                                          class="Polaris-Button Polaris-Button--pressable Polaris-Button--variantTertiary Polaris-Button--sizeMicro Polaris-Button--textAlignCenter"
                                          type="button"
                                          @click="searchText = ''"
                                        >
                                          <span
                                            class="Polaris-Text--root Polaris-Text--bodySm Polaris-Text--medium"
                                            >Cancel</span
                                          >
                                        </button>
                                        <div class="Polaris-Box">
                                          <div
                                            class="Polaris-InlineStack"
                                            style="--pc-inline-stack-wrap:wrap;--pc-inline-stack-flex-direction-xs:row"
                                          >
                                            <button
                                              class="Polaris-Button Polaris-Button--pressable Polaris-Button--variantSecondary Polaris-Button--sizeMicro Polaris-Button--textAlignCenter"
                                              type="button"
                                              @click="loadPage(1)"
                                            >
                                              <span
                                                class="Polaris-Text--root Polaris-Text--bodySm Polaris-Text--medium"
                                                >Search</span
                                              >
                                            </button>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="Polaris-IndexTable">
                    <div class="Polaris-IndexTable__IndexTableWrapper">
                      <table class="Polaris-DataTable__Table">
                        <thead>
                          <tr class="hidden md:table-row">
                            <th
                              class="Polaris-DataTable__Cell Polaris-DataTable__Cell--verticalAlignTop Polaris-DataTable__Cell--header"
                              scope="col"
                            >
                              Order
                            </th>
                            <th
                              class="Polaris-DataTable__Cell Polaris-DataTable__Cell--verticalAlignTop Polaris-DataTable__Cell--header"
                              scope="col"
                            >
                              Date
                            </th>
                            <th
                              class="Polaris-DataTable__Cell Polaris-DataTable__Cell--verticalAlignTop Polaris-DataTable__Cell--header"
                              scope="col"
                            >
                              Customer
                            </th>
                            <th
                              class="Polaris-DataTable__Cell Polaris-DataTable__Cell--verticalAlignTop Polaris-DataTable__Cell--header"
                              scope="col"
                            >
                              Total
                            </th>
                            <th
                              class="Polaris-DataTable__Cell Polaris-DataTable__Cell--verticalAlignTop Polaris-DataTable__Cell--header"
                              scope="col"
                            >
                              Payment status
                            </th>
                            <th
                              class="Polaris-DataTable__Cell Polaris-DataTable__Cell--verticalAlignTop Polaris-DataTable__Cell--header"
                              scope="col"
                            >
                              Fulfillment status
                            </th>
                            <th
                              class="Polaris-DataTable__Cell Polaris-DataTable__Cell--verticalAlignTop Polaris-DataTable__Cell--header"
                              scope="col"
                            ></th>
                            <th
                              class="Polaris-DataTable__Cell Polaris-DataTable__Cell--verticalAlignTop Polaris-DataTable__Cell--header"
                              scope="col"
                            ></th>
                            <th
                              class="Polaris-DataTable__Cell Polaris-DataTable__Cell--verticalAlignTop Polaris-DataTable__Cell--header"
                              scope="col"
                            ></th>
                          </tr>
                        </thead>
                        <tbody>
                          <OrderItem
                            v-for="order in orders.docs"
                            :key="order.id"
                            :order="order"
                            :shop-origin="shopOrigin"
                            @refreshCurrentPage="refreshCurrentPage"
                            @openCustomerInfo="openCustomerInfo"
                          />
                        </tbody>
                      </table>
                      <Pagination :page="orders" @pageChanged="loadPage" />
                    </div>
                  </div>
                  <div
                    class="align-middle inline-block min-w-full  overflow-hidden text-center py-16"
                    v-if="!isLoading && orders.docs && orders.docs.length === 0"
                  >
                    <h2 class="Polaris-Text--root Polaris-Text--bodyMd">
                      You don't have any order right now. We will be listing
                      them here as soon as order is placed.
                    </h2>
                  </div>
                </div>
              </div>
              <CustomerInfoModal
                v-if="showCustomerInfoModal"
                :phoneNumber="currentCustomerPhoneNumber"
                @close="closeCustomerInfo"
              />
            </div>
          </div>
        </div>
      </template>
    </Page>
  </div>
</template>

<script>
import Spinner from "vue-simple-spinner";

import Page from "./Page.vue";

import OrderItem from "./OrderItem";

import Pagination from "./Pagination";
// import ManualMessageAlert from "./ManualMessageAlert";
import CustomerInfoModal from "./CustomerInfoModal.vue";

export default {
  name: "OrderDetails",
  data() {
    return {
      pageTitle: "Orders",
      isLoading: false,
      searchText: "",
      currentCustomerPhoneNumber: null,
      showCustomerInfoModal: false
    };
  },
  components: {
    Page,
    OrderItem,
    Pagination,
    Spinner,
    // ManualMessageAlert,
    CustomerInfoModal
  },
  computed: {
    orders() {
      return this.$store.getters.getOrder;
    },
    config() {
      return this.$store.getters.getConfig;
    },
    shopOrigin() {
      const { shopOrigin } = this.$store.getters.getStore;
      return shopOrigin;
    }
  },
  created() {
    this.loadPage(1);
    this.$store.dispatch("getOrderTemplates");
    this.$store.dispatch("getConfig");
  },
  methods: {
    async loadPage(page) {
      this.isLoading = true;
      await this.$store.dispatch("getOrderList", {
        page,
        searchText: this.searchText
      });
      this.isLoading = false;
    },
    refreshCurrentPage() {
      this.searchText = "";
      const page = this.orders.page;
      this.loadPage(page);
    },
    openTemplates() {
      this.$router.push({ name: "Templates" });
    },
    openCustomerInfo(phoneNumber) {
      this.currentCustomerPhoneNumber = phoneNumber;
      this.showCustomerInfoModal = true;
    },
    closeCustomerInfo() {
      this.showCustomerInfoModal = false;
    }
  }
};
</script>

<style lang="scss" scoped></style>
